import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { apiPatchLead } from 'state/lead.state';
import { RootState } from 'state/store';

import DisplayLeadDetails from './DisplayLeadDetails';
import EditLeadDetails from './EditLeadDetails';

interface LeadDetailProps {
  editMode: boolean;
  onEditComplete?: Function;
}

const LeadDetails = (props: LeadDetailProps) => {
  const lead = useSelector((state: RootState) => state.lead.entity);
  const isCallCenterRoutingEnabled = useSelector(
    (state: RootState) =>
      !!state.lead.entity?.agent?.agentSetting?.settings?.inboundCalls?.callCenterRouting?.enabled
  );
  const dispatch = useDispatch();

  const { editMode, onEditComplete } = props;

  const saveLeadData = (data: any) => {
    dispatch(apiPatchLead(data));

    if (onEditComplete) {
      onEditComplete();
    }
  };

  if (!lead) return null;

  if (editMode) {
    return <EditLeadDetails lead={lead} onSubmit={saveLeadData} />;
  }

  return <DisplayLeadDetails lead={lead} isCallCenterRoutingEnabled={isCallCenterRoutingEnabled} />;
};

export default LeadDetails;
